import Select, { Option } from 'rc-select'
import './index.less'

export { Option }

export default Select
